(() => {
  const nav = document.querySelector('[data-gg-work-return]');
  const raw = new URL(location.href).searchParams.get('gg_work_return');
  if (!nav || !raw || !raw.startsWith('/') || raw.startsWith('//')) return;
  try {
    const destination = new URL(raw, location.origin);
    const match = destination.pathname.match(/^\/collections\/(franchise-[a-z0-9-]+)(?:\/[^/]+)?\/?$/);
    if (destination.origin !== location.origin || !match || !nav.dataset.allowedHandles.split('|').includes(match[1])) return;
    nav.querySelector('[data-gg-work-back]').href = destination.pathname + destination.search + destination.hash;
    nav.hidden = false;
  } catch (_) { /* A direct or invalid-context visit has no inferred return target. */ }
})();
